import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const submitContact = (payload) => api.post("/contact", payload).then((r) => r.data);

export const startDonation = (lookup_key) =>
  api
    .post("/payments/checkout", { lookup_key, origin_url: window.location.origin })
    .then((r) => r.data);

export const getPaymentStatus = (sessionId) =>
  api.get(`/payments/status/${sessionId}`).then((r) => r.data);
